import React from "react";
import "./style.scss";

import avatar1 from "../../../../../static/img/ellipse-1.png";
import avatar2 from "../../../../../static/img/ellipse-1-1.png";
import avatar3 from "../../../../../static/img/ellipse-1-2.png";
import avatar4 from "../../../../../static/img/ellipse-1-3.png";

const REVIEWS = [
  {
    name: "Sarah M.",
    role: "Hobbyist Collector",
    quote:
      "CardsFolio transformed how I manage my collection. No more mess, just pure collecting joy!",
    avatar: avatar1,
  },
  {
    name: "James T.",
    role: "Vintage Enthusiast",
    quote:
      "The time I save with CardsFolio is incredible. The filters and search are game-changers.",
    avatar: avatar2,
  },
  {
    name: "Emily R.",
    role: "New Collector",
    quote:
      "I love that I keep 100% of my sales. It’s simple, fair, and made for collectors like me.",
    avatar: avatar3,
  },
  {
    name: "Mark L.",
    role: "Veteran Collector",
    quote:
      "Finally, a platform built for collectors, not accountants. It just works.",
    avatar: avatar4,
  },
];

const ReviewsSubsection = ({ t }) => {
  return (
    <div className="rv">
      <header className="rv-head">
        <h2 className="rv-title">{t("What Collectors Are Saying")}</h2>
        <p className="rv-sub">
          {t("Real feedback from passionate collectors just like you.")}
        </p>
      </header>

      <ul className="rv-grid" role="list">
        {REVIEWS.slice(0, 3).map((r, i) => (
          <li key={i} className="rv-card">
            <img className="rv-avatar" src={r.avatar} alt="" />
            <div className="rv-meta">
              <br />
              <br />
              <span className="rv-name">{r.name}</span>
              <span className="rv-role"> — {t(r.role)}</span>
            </div>
            <p className="rv-quote">{t(r.quote)}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ReviewsSubsection;
